import { apiGet, apiPost } from 'shared/services/api/resource';
import { MURAL_POSTS } from 'modules/jogador/mural/content';
import { MuralPost } from 'modules/jogador/mural/types';

export function fetchMuralPosts(): Promise<MuralPost[]> {
  return apiGet(MURAL_POSTS, '/mural');
}

export interface PublishRachaInput {
  authorName: string;
  sport: string;
  location: string;
  when: string;
  level: string;
  spots: number;
  notes: string;
}

export function publishRacha(input: PublishRachaInput): Promise<MuralPost> {
  const newPost: MuralPost = {
    id: `racha-${Math.random().toString(36).slice(2, 9)}`,
    kind: 'racha',
    authorName: input.authorName,
    timeAgoLabel: 'agora',
    levelLabel: `nível ${input.level}`,
    text: input.notes.trim() || `Bora fechar um racha de ${input.sport}?`,
    courtInfo: `${input.location} · ${input.when}`,
    spotsLabel: `1/${input.spots}`,
    commentCount: 0,
  };

  return apiPost(newPost, '/mural', input);
}

export function joinMuralPost(postId: string) {
  return apiPost({ id: postId }, `/mural/${postId}/join`, undefined, 150);
}
